import React from "react";
import HelperText from "../../../../../components/atoms/HelperText";

export function rankScoresExplanations(databaseName) {
  if (databaseName === "SIFT") {
    return (
      <HelperText
        customText="SIFT (SIFTori) scores were first converted to SIFTnew=1-SIFTori,
		then ranked among all SIFTnew scores in dbNSFP. The rankscore is the ratio of 
		the rank the SIFTnew score over the total number of SIFTnew scores in dbNSFP. 
		If there are multiple scores, only the most damaging (largest) rankscore is presented.
		The rankscores range from 0.00964 to 0.91255."
      />
    );
  }
  if (databaseName === "SIFT4G") {
    return (
      <HelperText
        customText="SIFT4G scores were first converted to SIFT4Gnew=1-SIFT4G,
    then ranked among all SIFT4Gnew scores in dbNSFP. The rankscore is the ratio of 
    the rank the SIFT4Gnew score over the total number of SIFT4Gnew scores in dbNSFP. 
    If there are multiple scores, only the most damaging (largest) rankscore is presented."
      />
    );
  }
  if (databaseName === "PROVEAN") {
    return (
      <HelperText
        customText="PROVEANori were first converted to PROVEANnew=1-(PROVEANori+14)/28,
    then ranked among all PROVEANnew scores in dbNSFP. The rankscore is the ratio of 
    the rank the PROVEANnew score over the total number of PROVEANnew scores in dbNSFP. 
    If there are multiple scores, only the most damaging (largest) rankscore is presented.
    The scores range from 0 to 1."
      />
    );
  }
  if (databaseName === "MVP") {
    return (
      <HelperText
        customText="MVP scores were ranked among all MVP scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of MVP scores in dbNSFP. "
      />
    );
  }
  if (databaseName === "MutPred") {
    return (
      <HelperText
        customText="MutPred scores were ranked among all MutPred scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of MutPred scores in dbNSFP."
      />
    );
  }
  if (databaseName === "PrimateAI") {
    return (
      <HelperText
        customText="PrimateAI scores were ranked among all PrimateAI scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of PrimateAI scores in dbNSFP. "
      />
    );
  }
  if (databaseName === "BayesDel noAF") {
    return (
      <HelperText
        customText="BayesDel_noAF scores were ranked among all BayesDel_noAF scores in dbNSFP.
    The rankscore is the ratio of the rank of the score over the total number of BayesDel_noAF scores in dbNSFP."
      />
    );
  }
  if (databaseName === "BayesDel addAF") {
    return (
      <HelperText
        customText="BayesDel_addAF scores were ranked among all BayesDel_addAF scores in dbNSFP.
    The rankscore is the ratio of the rank of the score over the total number of BayesDel_addAF scores in dbNSFP. "
      />
    );
  }
  if (databaseName === "LIST-S2") {
    return (
      <HelperText
        customText="LIST-S2 scores were ranked among all LIST-S2 scores in dbNSFP. The rankscore is the ratio
    of the rank of the score over the total number of LIST-S2 scores in dbNSFP."
      />
    );
  }
  if (databaseName === "MutationTaster") {
    return (
      <HelperText
        customText="The MTori (Mutation Taster) scores were first converted. If the prediction
    is 'A' or 'D', MTnew=MTori. If the prediction is 'N' or 'P', MTnew=1-MTori. Then MTnew 
    scores were ranked among all MTnew scores in dbNSFP. If there are multiple scores of an 
    SNV, only the largest MTnew was used in ranking. The rankscore is the ratio of the
    rank of the score over the total number of MTnew scores in dbNSFP. The scores range
    from 0.08979 to 0.81001."
      />
    );
  }
  if (databaseName === "Mutation assessor") {
    return (
      <HelperText
        customText="Mutation assessor (MAori) scores were ranked among all MAori scores in dbNSFP.
    The rankscore is the ratio of the rank of the score over the total number of MAori 
    scores in dbNSFP. The scores range from 0 to 1."
      />
    );
  }
  if (databaseName === "FATHMM") {
    return (
      <HelperText
        customText="FATHMM (FATHMMori) scores were first converted to
    FATHMMnew=1-(FATHMMori+16.13)/26.77, then ranked among all FATHMMnew scores in dbNSFP. 
    The rankscore is the ratio of the rank of the score over the total number of FATHMMnew 
    scores in dbNSFP. If there are multiple scores, only the most damaging (largest) 
    rankscore is presented. The scores range from 0 to 1."
      />
    );
  }
  if (databaseName === "FATHMM-MKL") {
    return (
      <HelperText
        customText="FATHMM-MKL coding scores were ranked among all FATHMM-MKL coding
    scores in dbNSFP. The rankscore is the ratio of the rank of the score over the total number 
    of FATHMM-MKL coding scores in dbNSFP."
      />
    );
  }
  if (databaseName === "FATHMM-XF") {
    return (
      <HelperText
        customText="FATHMM-XF coding scores were ranked among all FATHMM-XF coding
    scores in dbNSFP. The rankscore is the ratio of the rank of the score over the total number 
    of FATHMM-XF coding scores in dbNSFP."
      />
    );
  }
  if (databaseName === "LRT") {
    return (
      <HelperText
        customText="LRT scores were first converted as LRTnew=1-LRT*0.5 if
    Omega<1, or LRTnew=LRT*0.5 if Omega>=1. Then LRTnew scores were ranked among all 
    LRTnew scores in dbNSFP. The rankscore is the ratio of the rank over the total number 
    of the scores in dbNSFP. The scores range from 0.00162 to 0.8433."
      />
    );
  }
  if (databaseName === "DEOGEN2") {
    return (
      <HelperText
        customText="DEOGEN2 scores were ranked among all DEOGEN2 scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of DEOGEN2 scores in dbNSFP."
      />
    );
  }
  if (databaseName === "M-CAP") {
    return (
      <HelperText
        customText="M-CAP scores were ranked among all M-CAP scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of M-CAP scores in dbNSFP."
      />
    );
  }
  if (databaseName === "DANN") {
    return (
      <HelperText
        customText="DANN scores were ranked among all DANN scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of DANN scores in dbNSFP."
      />
    );
  }

  if (databaseName === "MetaLR") {
    return (
      <HelperText
        customText="MetaLR scores were ranked among all MetaLR scores in dbNSFP. The rankscore
    is the ratio of the rank of the score over the total number of MetaLR scores in dbNSFP. 
    The scores range from 0 to 1."
      />
    );
  }
  if (databaseName === "MetaSVM") {
    return (
      <HelperText
        customText="MetaSVM scores were ranked among all MetaSVM scores in dbNSFP.
    The rankscore is the ratio of the rank of the score over the total number of MetaSVM 
    scores in dbNSFP. The scores range from 0 to 1."
      />
    );
  }
  if (databaseName === "MetaRNN") {
    return (
      <HelperText
        customText="MetaRNN scores were ranked among all MetaRNN scores in dbNSFP. The rankscore
    is the ratio of the rank of the score over the total number of MetaRNN scores in dbNSFP. 
    The scores range from 0 to 1."
      />
    );
  }
  if (databaseName === "REVEL") {
    return (
      <HelperText
        customText="REVEL scores were ranked among all REVEL scores in dbNSFP. The rankscore is
    the ratio of the rank of the score over the total number of REVEL scores in dbNSFP."
      />
    );
  }
  if (databaseName === "EIGEN") {
    return (
      <HelperText
        customText="Eigen-raw scores were ranked among all Eigen-raw scores in dbNSFP. The rankscore
    is the ratio of the rank of the score over the total number of Eigen-raw scores in dbNSFP."
      />
    );
  }
  if (databaseName === "EIGEN PC") {
    return (
      <HelperText
        customText="Eigen-PC-raw scores were ranked among all Eigen-PC-raw scores in
    dbNSFP. The rankscore is the ratio of the rank of the score over the total number 
    of Eigen-PC-raw scores in dbNSFP."
      />
    );
  }

  return null;
}
